
  import * as storyblokRuntime$_8t9_45dUX8gI9J3QuN8L2_1AyA78Wynutv7bkM7TjIDSo from '/codebuild/output/src3932096889/src/bitbucket.org/magusa/cavu-workspaces/node_modules/.pnpm/@nuxt+image@1.11.0_db0@0.3.2_ioredis@5.7.0_magicast@0.3.5/node_modules/@nuxt/image/dist/runtime/providers/storyblok'
import * as ipxRuntime$_29uo2CLC4mYrm4EeDKolrNxOVe8WifE96QkaoKCrR0 from '/codebuild/output/src3932096889/src/bitbucket.org/magusa/cavu-workspaces/node_modules/.pnpm/@nuxt+image@1.11.0_db0@0.3.2_ioredis@5.7.0_magicast@0.3.5/node_modules/@nuxt/image/dist/runtime/providers/ipx'
  
  export const imageOptions = {
    ...{
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
},
    providers: {
        ['storyblok']: { provider: storyblokRuntime$_8t9_45dUX8gI9J3QuN8L2_1AyA78Wynutv7bkM7TjIDSo, defaults: {"baseURL":"https://a.storyblok.com"} },
  ['ipx']: { provider: ipxRuntime$_29uo2CLC4mYrm4EeDKolrNxOVe8WifE96QkaoKCrR0, defaults: {} }
    }
  }
